import React, { useEffect, useState } from 'react';
import qs from 'query-string';
//import $ from 'jquery';
//import moment from 'moment';
import ContaForm from './ContaForm';
import api from '../../../services/api';
import loadingGif from '../../../img/loading-gif.gif';

function Conta(props) {
	const novaContaModal = React.createRef();

	const [contas, setContas] = useState([]);
	//const [params, setParams] = useState({});
	const [loading, setLoading] = useState(true);
	const [modalVisibleNovo, setModalVisibleNovo] = useState(false);
	//const [modalVisibleEdit, setModalVisibleEdit] = useState(false);
	//const [conta, setConta] = useState();

	useEffect(() => {
		let qparams = Object.assign(
			{
				q: '',
			},
			qs.parse(props.location.search)
		);
		getContas(qparams);
	}, [props.location.search]);

	function getContas(params = {}) {
		//var self = this;

		return api.get('/admin/conta/json', params).then(({ data, status }) => {
			if (status === 200) {
				setContas(data.contas);
				setLoading(false);
				////console.log('contas');
			} else if (status === 500) {
				alert('Erro ao buscar Contas');
			}
		});
	}

	function removeListItem(conta) {
		const p = [...contas];
		let index = -1;
		for (let i = 0; i < p.length; i++) {
			if (p[i].id === conta.id) {
				index = i;
			}
		}

		if (index !== -1) {
			p.splice(index, 1);
		}

		setContas([...p]);
	}

	async function remove(conta, setStateRemove) {
		if (!window.confirm('Deseja Realmente excluir esse registro? ')) {
			return;
		}
		setStateRemove(true);

		try {
			const response = await api.delete('/admin/conta/' + conta.id);
			//console.log(response);
			const { data, status } = response;

			if (data && status === 200) {
				removeListItem(conta);
			}

			setStateRemove(false);
		} catch (error) {
			//console.log(error);
			if (error.response.status === 401){
				window.location.reload();
				
			}
			setStateRemove(false);
		}

		//var self = this;
		/*
        $.ajax({
            url: '/admin/conta/' + conta.id,
            type: 'DELETE'
        })
        .then(function(data) {
            if (data == true) {
                self.getcontas(self.state.params);
            }
        })
        .catch(////console.log);
        */
	}

	function updateConta(conta) {
		////console.log(conta);
		const p = [...contas];
		let index = -1;

		for (let i = 0; i < p.length; i++) {
			if (p[i].id === conta.id) {
				index = i;
			}
		}

		if (index !== -1) {
			//u.splice(index,1);
			////console.log(p[index]);
			p[index] = conta;
			////console.log(p[index]);
		} else {
			p.push(conta);
		}

		setContas([...p]);
	}

	return (
		<div style={{paddingTop:30,paddingLeft:15}} className='Conta row'>
			<div className='col-md-12 header-page p-3'>
				<h2 className='title'>
					Contas
					<div className='d-inline-block ml-4'>
						<button
							className='btn btn-sm btn-success'
							data-toggle='modal'
							data-target='#novacontaForm'
							onClick={() => {
								novaContaModal.current.resetForm();
								setModalVisibleNovo(true);
							}}>
							Nova Conta
						</button>
					</div>
				</h2>
				<ContaForm
					ref={novaContaModal}
					elementId='novacontaForm'
					callback={updateConta}
					modalVisible={modalVisibleNovo}
					setModalVisible={setModalVisibleNovo}
				/>
			</div>
			<div className='col-md-12'>
				<div className='card border-0 mt-4'>
					<div className='card-body'>
						<table className='table'>
							<thead>
								<tr>
									<th></th>
									<th>Nome</th>
									<th>Código</th>
									<th>CNPJ</th>
									<th>CEP</th>
									<th>Provedor</th>
									<th>Descrição</th>
									<th></th>
								</tr>
							</thead>
								{loading ? (
									<tbody>
										<tr>
											<td className='text-center'>
												<div className='Skeleton'></div>
											</td>
											<td>
												{' '}
												<div className='Skeleton'></div>
											</td>
											<td>
												{' '}
												<div className='Skeleton'></div>
											</td>
											<td>
												<div className='Skeleton'></div>
											</td>
											<td>
												{' '}
												<div className='Skeleton'></div>
											</td>
											<td>
												{' '}
												<div className='Skeleton'></div>
											</td>
											<td>
												{' '}
												<div className='Skeleton'></div>
											</td>
											<td>
												<div className='Skeleton'></div>
											</td>
										</tr>
										<tr>
											<td className='text-center'>
												<div className='Skeleton'></div>
											</td>
											<td>
												{' '}
												<div className='Skeleton'></div>
											</td>
											<td>
												{' '}
												<div className='Skeleton'></div>
											</td>
											<td>
												<div className='Skeleton'></div>
											</td>
											<td>
												{' '}
												<div className='Skeleton'></div>
											</td>
											<td>
												{' '}
												<div className='Skeleton'></div>
											</td>
											<td>
												{' '}
												<div className='Skeleton'></div>
											</td>
											<td>
												<div className='Skeleton'></div>
											</td>
										</tr>
										<tr>
											<td className='text-center'>
												<div className='Skeleton'></div>
											</td>
											<td>
												{' '}
												<div className='Skeleton'></div>
											</td>
											<td>
												{' '}
												<div className='Skeleton'></div>
											</td>
											<td>
												<div className='Skeleton'></div>
											</td>
											<td>
												{' '}
												<div className='Skeleton'></div>
											</td>
											<td>
												{' '}
												<div className='Skeleton'></div>
											</td>
											<td>
												{' '}
												<div className='Skeleton'></div>
											</td>
											<td>
												<div className='Skeleton'></div>
											</td>
										</tr>
									</tbody>
								) : (
									<tbody>
										{contas.map((conta) => (
											<ContaContainer
												key={conta.id}
												conta={conta}
												remove={remove}
												updateConta={updateConta}
											/>
										))}
									</tbody>
								)}
							
						</table>
					</div>
				</div>
			</div>
		</div>
	);
}

function ContaContainer(props) {
	const { conta, remove, updateConta } = props;

	const [modalVisibleEdit, setModalVisibleEdit] = useState(false);

	const [loading, setLoading] = useState(false);

	return (
		<tr key={conta.id}>
			<ContaForm
				elementId={'form' + conta?.id}
				item={conta}
				callback={updateConta}
				modalVisible={modalVisibleEdit}
				setModalVisible={setModalVisibleEdit}
			/>

			<td className='text-center'>
				<span
					style={{ fontSize: '1.2em' }}
					className={
						conta.situacao === '1' || conta.situacao === 1
							? 'text-success'
							: 'text-danger'
					}
					title={conta.situacao === '1' ? 'Ativa' : 'Desativada'}>
					&#x029BF;
				</span>
			</td>
			<td>{conta.nome}</td>
			<td>{conta.codigo}</td>
			<td>{conta.cnpj}</td>
			<td>{conta.cep}</td>
			<td>{conta.provedor}</td>
			<td>{conta.descricao}</td>
			<td>
				<div className='float-right'>
					<button
						onClick={(e) => {
							//setConta(conta);

							e.preventDefault();

							if (loading) return;

							setModalVisibleEdit(true);
						}}
						className='btn btn-sm btn-primary mr-1'
						data-toggle='modal'
						data-target={'#form' + conta.id}>
						Editar
					</button>
					<button
						className='btn btn-sm btn-danger'
						onClick={() => remove(conta, setLoading)}>
						{loading ? (
							<img className='loadingImg' src={loadingGif} alt='loading' />
						) : (
							'Remover'
						)}{' '}
					</button>
				</div>
			</td>
		</tr>
	);
}

export default Conta;
